module.exports = __webpack_public_path__ + "img/CZ49240901.9a46360c.png";